import { useSupabaseLoader } from "../../../server/supabase/hooks";

/** Assets in the Content Library, across every folder; archiving sets `deleted_at`. */
export function useAssetCount(): ReturnType<typeof useSupabaseLoader<number>> {
  return useSupabaseLoader(async ({ supabase, account_id }) => {
    const { count, error } = await supabase
      .from("digital_asset")
      .select("id", { count: "exact", head: true })
      .eq("account_id", account_id)
      .is("deleted_at", null);
    if (error) throw error;

    return count ?? 0;
  }, []);
}
